/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-24 16:20:16
 * @LastEditTime: 2022-01-05 15:45:33
 * @LastEditors: zhao - 🍉
 * @Description: 划账记录
 * @FilePath: /zhzj-admin/src/services/transferRecordLog.js
 */


import request from "../utils/request";


/**
 * 划账记录 - 获取列表数据
 * @param {*} params 
 * @returns 
 */
export function fetchTransferRecordLogList(data) {
    return request({
        url: '/platform/merchantTransferRecordLog/findPage',
        method: 'post',
        data
    })
}

/**
 * 划账提醒记录 - 获取列表数据
 * @param {*} params
 * @returns
 */
export function fetchTransferRecordReminderList(data) {
    return request({
        url: '/platform/merchantCollectionSchedule/getRemittanceReminderPage',
        method: 'post',
        data
    })
}

/**
 * 划账记录 - 获取详情数据
 * @param {*} params 
 * @returns 
 */
export function fetchTransferRecordLogGet(params) {
    return request({
        url: '/platform/merchantTransferRecordLog/getMerchantTransferRecordLogInfo',
        method: 'post',
        params
    })
}

/**
 * 划账结算记录 - 获取划账结算记录详情数据
 * @param {*} params
 * @returns
 */
export function fetchMerchantTransferRecordDetailsLogByIdGet(params) {
    return request({
        url: '/platform/merchantTransferRecordLog/getMerchantTransferRecordDetailsLogById',
        method: 'post',
        params
    })
}

/**
 * 划账记录 - 新增
 * @param {*} data 
 * @returns 
 */
 export function fetchTransferRecordLogAdd(data) {
    return request({
        url: '/platform/merchantTransferRecordLog/create',
        method: 'post',
        data
    })
}
/**
 * 划账记录 - 修改
 * @param {*} data 
 * @returns 
 */
 export function fetchTransferRecordLogUpdate(data) {
    return request({
        url: '/platform/merchantTransferRecordLog/edit',
        method: 'post',
        data
    })
}


/**
 * 获取划账记录审批流程列表
 * @param {*} params 
 * @returns 
 */
export function fetchTransferRecordLogFlowList(params) {
    return request({
        url: '/platform/merchantTransferRecordLog/getFlowList',
        method: 'post',
        params
    })
}
/**
 * 获取短信验证码
 * @param {*} params 
 * @returns 
 */
export function fetchTransferRecordLogSendSmsCode(params) {
    return request({
        url: '/platform/merchantTransferRecordLog/sendVerifyCode',
        method: 'post',
        params
    })
}

/**
 * 划账记录 - 流程审批
 * @param {*} params 
 * @returns 
 */
export function fetchTransferRecordLogFlowApproval(data) {
    return request({
        url: '/platform/merchantTransferRecordLog/flowApproval',
        method: 'post',
        data
    })
}

export function fetchTransferRecordLogSftpUpload(params) {
    return request({
        url: '/platform/merchantTransferRecordLog/sftpUploadFile',
        method: 'post',
        params
    })
}

export function fetchTransferRecordLogFlowNeedSms(params) {
    return request({
        url: '/platform/merchantTransferRecordLog/whetherNeedSMS',
        method: 'post',
        params
    })
}


// WEBPACK FOOTER //
// ./src/services/transferRecordLog.js